import styled from 'styled-components'

const Root = styled.div`
    height: 100vh;
    width: 100vw;
    display: flex;
`

const Artboard = styled.div`
    flex: 0.56;
    height: 100%;
    background-color: #f7f7f7;
`

const Main = styled.div`
    flex: 0.55;
    height: 100%;
    background-color: #fff;
    padding: 70px 77px 50px 160px;
    box-sizing: border-box;
    & > div:nth-child(2){
        height: 100%;
    }
`
const LogoContainer = styled.div`
    display: flex;
    flex-direction: column-reverse;
    height: 118px;
    margin-left: 128px;
    & .SVGInline-svg {
        height: 50px;
    }
`

const ArtContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 72%;
    & img {
        height: 219px;
    }
`

const Caption = styled.div`
    width: ${ props => props.width ||'318px' };
    height: 54px;
    margin-top: 23px;
    font-family: Lato;
    font-size: 16px;
    font-weight: normal;
    font-style: italic;
    font-stretch: normal;
    line-height: 1.69;
    letter-spacing: normal;
    text-align: center;
    color: #2e4b62;
`

export {
    Root, Artboard, Main, LogoContainer, ArtContainer, Caption
}
